var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("viewForm", {
    attrs: {
      "is-edit": true,
      info: _vm.info,
      "set-flag": _vm.GOODS_COMBO_TYPES.ORDINARY,
    },
    on: { reFresh: _vm.reFresh },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }